import React from "react";
import { OrderView } from "./OrderView";
import {
  CrudlStatus,
  ToggleState,
  PageState
} from "../../common/config/AppConstants";
import { ViewState } from "../../common/config/AppConstants";
import { ValidateState } from "../../common/config/AppConstants";
import * as pr from "../../common/PrimeComponents";
import * as format from "../../common/FormatFunctions";

import { LoadScreen } from "../Common/LoadScreen";
import { ErrorScreen } from "../Common/ErrorScreen";

export class OrderController extends React.Component {
  state = {
    pageName: "OrderController",
    pageState: PageState.IDLE,
    editLoading: true,

    //DISPLAY STATES
    viewState: ViewState.TABLE,

    validateState: ValidateState.NONE,
    crudlState: CrudlStatus.LIST,
    menuState: [],

    // DATA TABLE
    expandedRows: null,
    tableColumns: [],
    columnOptions: [],
    rowCount: 10,
    settingsToggle: ToggleState.OFF,

    // DETAILS
    orderList: null,
    originalEditedOrder: "",
    editedOrder: null,
    deletedOrderItemList: [],

    productList: [],
    hasOverlays: true
  };

  componentDidMount = async () => {
    this.initialDataRender();
  };

  componentDidCatch = (error, info) => {
    console.log("This went in here");

    //COMPONENT ISSUE CHECK IF THIS ERROR HANDLING IS CORRECT
    this.setError(false, "componentDidCatch", error);
  };

  initialDataRender = async () => {
    this.setViewModel();
    await this.setPageData();
  };

  setError = (critical, methodName, error) => {
    this.props.log.error(error.message);
    if (critical) {
      this.setCriticalError();
    } else {
      this.setStandardError();
    }
    this.props.viewModel.createException(
      error,
      this.state.pageName,
      methodName
    );
  };
  setStandardError = () => {
    //MORE CAN BE ADDED HERE AS APPROPRIATE
    this.showError("Order");
    this.setState({ pageState: PageState.IDLE });
  };
  setCriticalError = () => {
    //SET ERROR STATE OF PAGE
    this.setState({ pageState: PageState.ERROR });
  };

  setViewModel = () => {
    try {
      this.props.viewModel.updateState = this.updateState;
      this.props.viewModel.showError = this.showError;
      this.props.viewModel.showSuccess = this.showSuccess;
      this.props.viewModel.showEmpty = this.showEmpty;
    } catch (error) {
      this.setError(false, "setViewModel", error);
    }
  };

  setPageData = async () => {
    try {
      this.setState({ pageState: PageState.LOADING });

      this.menuState(CrudlStatus.LIST);

      this.setUpProductColumns();
      this.setUpColumns();

      await this.props.viewModel.getCustomers();
      await this.props.viewModel.getProducts();
      await this.props.viewModel.getOrders();
      await this.props.viewModel.getCatalogues();

      this.setState({
        pageState: PageState.IDLE
      });
    } catch (error) {
      this.setError(true, "setPageData", error);
    }
  };
  showError = (display, crudlStatus) => {
    try {
      this.props.feedback.showError(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showError", error);
    }
  };
  showSuccess = (display, crudlStatus) => {
    try {
      this.props.feedback.showSuccess(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showSuccess", error);
    }
  };
  showEmpty = display => {
    try {
      this.props.feedback.showEmpty(this.growl, display);
    } catch (error) {
      this.setError(false, "showEmpty", error);
    }
  };

  getStateValuesAsObject = () => {
    try {
      var externalObject = {};
      externalObject.orderBean = this.state.editedOrder;
      externalObject.orderItemList = this.state.editedOrder.orderItemList;
      externalObject.deletedOrderItemList = this.state.deletedOrderItemList;

      return externalObject;
    } catch (error) {
      this.setError(false, "getStateValuesAsObject", error);
    }
  };

  updateBean = async (field, value) => {
    try {
      this.props.log.info(
        "Updating : [" + field + "] with value [" + value + "]"
      );
      await this.setState(prevState => ({
        editedOrder: {
          // object that we want to update
          ...prevState.editedOrder, // keep all other key-value pairs
          [field]: value
        }
      }));
    } catch (error) {
      this.setError(false, "updateBean", error);
    }
  };

  updateState = (key, value) => {
    try {
      this.setState({ [key]: value });
    } catch (error) {
      this.setError(false, "updateState", error);
    }
  };

  toggleOverlay = value => {
    try {
      this.props.log.info("Checking Overlays");
      if (this.state.hasOverlays) {
        this.props.log.info("Checking Overlays : true");
        if (format.isFunction(this.props.toggleTopbar)) {
          this.props.log.info("Checking Overlay Function : exists");
          this.props.toggleTopbar(value);
        }
      }
    } catch (error) {
      this.setError(false, "toggleOverlay", error);
    }
  };
  validateChanges = () => {
    try {
      if (this.state.editedOrder === null) {
        this.discardChanges();
      } else {
        if (
          format.isJsonEqual(
            this.state.originalEditedOrder,
            this.state.editedOrder
          )
        ) {
          this.discardChanges();
        } else {
          this.setState({ validateState: ValidateState.CONFIRM });
        }
      }
    } catch (error) {
      this.setError(false, "validateChanges", error);
    }
  };

  discardChanges = () => {
    try {
      this.setState({
        viewState: ViewState.TABLE,
        toggleChangesMade: false,
        crudlState: CrudlStatus.LIST,
        selectedOrder: null
      });
      this.toggleOverlay(ToggleState.ON);
      this.menuState(CrudlStatus.LIST);
    } catch (error) {
      this.setError(false, "discardChanges", error);
    }
  };

  checkRequiredFields = () => {
    try {
      if (format.isNotNull(this.state.editedOrder)) {
        return format.validateValues([
          this.state.editedOrder.orderItemList,
          this.state.editedOrder.shortDescription,
          this.state.editedOrder.clientId
        ]);
      } else {
        return true;
      }
    } catch (error) {
      this.setError(false, "checkRequiredFields", error);
    }
  };

  menuState = crudlStatus => {
    try {
      this.setState({
        menuState: pr.getBreadcrumbMenuState(crudlStatus, "Order", "#/orders")
      });
    } catch (error) {
      this.setError(false, "menuState", error);
    }
  };

  executeCrudl = async stayOnPage => {
    try {
      if (format.isNotNull(this.state.crudlState)) {
        this.props.log.info(
          "Executing " +
            this.state.crudlState.value +
            " Staying[" +
            stayOnPage +
            "]"
        );
        if (this.state.crudlState === CrudlStatus.CREATE) {
          await this.addOrder(stayOnPage);
        }
        if (this.state.crudlState === CrudlStatus.UPDATE) {
          await this.updateOrder(stayOnPage);
        }
        if (this.state.crudlState === CrudlStatus.DELETE) {
          await this.deleteOrder();
        }
      }
    } catch (error) {
      this.setError(false, "executeCrudl", error);
    }
  };

  executeSetup = (requiredCrudlState, data) => {
    try {
      if (format.isNotNull(requiredCrudlState)) {
        this.props.log.info("Setting up " + requiredCrudlState.value);
        if (requiredCrudlState === CrudlStatus.CREATE) {
          this.createSetup();
        }
        if (requiredCrudlState === CrudlStatus.VIEW) {
          this.viewSetup(data);
        }
        if (requiredCrudlState === CrudlStatus.UPDATE) {
          this.updateSetup(data);
        }
        if (requiredCrudlState === CrudlStatus.DELETE) {
          this.deleteSetup(data);
        }
      }
    } catch (error) {
      this.setError(false, "executeSetup", error);
    }
  };

  //PRODUCT SPECIFIC
  hideProductEditor = () => {
    try {
      var currentPartList = format.deepCopy(this.state.productList);
      currentPartList.forEach(element => {
        delete element.quantityAdded;
        delete element.quantity;
        delete element.shipTogether;
        delete element.manufactureTogether;
      });
      this.setState({
        productList: currentPartList,
        productAddModal: false
      });
    } catch (error) {
      this.setError(false, "hideProductEditor", error);
    }
  };
  removeProductFromSelectedProducts = bean => {
    try {
      var localProductList = format.deepCopy(
        this.state.editedOrder.orderItemList
      );
      var updatedLocalProductList = [];
      var deletedLocalOrderItemList = [];
      localProductList.forEach(element => {
        if (element.id === bean.id) {
          element.crudlStatus = CrudlStatus.DELETE.value;
          deletedLocalOrderItemList.push(element);
        } else {
          updatedLocalProductList.push(element);
        }
      });
      if (this.state.crudlState === CrudlStatus.UPDATE) {
        this.updateBean("orderItemList", updatedLocalProductList);
        this.updateState("deletedOrderItemList", deletedLocalOrderItemList);
      } else {
        this.updateBean("orderItemList", updatedLocalProductList);
      }
    } catch (error) {
      this.setError(false, "removeProductFromSelectedProducts", error);
    }
  };

  updateProductSelected = (f, bean) => {
    try {
      f.preventDefault();

      var localBean = bean;
      var elementFound = false;
      var localOrderItemList = [];
      if (format.isNotNull(this.state.editedOrder.orderItemList)) {
        localOrderItemList = format.deepCopy(
          this.state.editedOrder.orderItemList
        );
      }

      localOrderItemList.forEach(element => {
        if (element.productId === localBean.id) {
          elementFound = true;
          this.updateOrderItemQuantity(element, localBean);
        }
      });

      if (elementFound === false) {
        localOrderItemList.push(this.props.viewModel.createNewOrderItem(bean));
      }
      var currentProductList = format.deepCopy(this.state.productList);
      currentProductList.forEach(element => {
        if (element.id === localBean.id) {
          element.quantityAdded = true;
        }
      });
      this.setState({
        productSelected: {},
        productAdded: false,
        productList: currentProductList
      });
      this.updateBean("orderItemList", localOrderItemList);
    } catch (error) {
      this.setError(false, "updateProductSelected", error);
    }
  };
  updateOrderItemQuantity = (orderItem, bean) => {
    try {
      var partProductJson = JSON.parse(orderItem.partProductJson);
      if (format.isNotNull(partProductJson.products)) {
        partProductJson.products.forEach(element => {
          element.quantity = (
            parseInt(element.quantity, 10) + parseInt(bean.quantity, 10)
          ).toString();
        });
      }
      orderItem.partProductJson = JSON.stringify(partProductJson);
      orderItem.quantity = (
        parseInt(orderItem.quantity, 10) + parseInt(bean.quantity, 10)
      ).toString();
    } catch (error) {
      this.setError(false, "updateOrderItemQuantity", error);
    }
  };

  // DONT REQUIRE TRY CATCHES AS ACCESSED BY ANOTHER METHOD IN THIS CLASS ONLY
  setUpProductColumns = () => {
    let localCols = [];
    localCols.push(pr.getTableColumn("name", "Name"));
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(pr.getTableColumn("operationalType", "Type"));

    this.setState({ productTableColumns: localCols });
    var colOptions = pr.getColumnOptions(localCols);
    this.setState({ productColOptions: colOptions });
  };

  setUpColumns = () => {
    let localCols = [];
    localCols.push(pr.getTableColumn("orderSequenceNo", "Order No"));
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(
      pr.getTableColumn("customerDetails.businessName", "Customer")
    );
    localCols.push(pr.getTableColumn("purchaseOrderNo", "Purchase Order No"));
    localCols.push(
      pr.getTableColumn("clientReferenceNumber", "Client Reference")
    );
    localCols.push(pr.getTableColumn("shipTogether", "Ship Together"));
    localCols.push(pr.getTableColumn("status", "Status"));
    localCols.push(
      pr.getTableColumn("dateOrderReceivedToDisplay", "Order Date")
    );

    this.setState({ tableColumns: localCols });
    var colOptions = pr.getColumnOptions(localCols);
    this.setState({ columnOptions: colOptions });
  };

  columnToggle = event => {
    this.setState({ tableColumns: event.value });
  };

  createSetup = () => {
    window.scrollTo(0, 0);
    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.CREATE,
      editedOrder: {},
      originalEditedOrder: JSON.stringify({})
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.CREATE);
  };

  updateSetup = data => {
    window.scrollTo(0, 0);

    data = this.additionalParseFunctions(data);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.UPDATE,
      editedOrder: data,
      originalEditedOrder: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.UPDATE);
  };

  viewSetup = data => {
    window.scrollTo(0, 0);

    data = this.additionalParseFunctions(data);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.VIEW,
      editedOrder: data,
      originalEditedOrder: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.VIEW);
  };

  deleteSetup = data => {
    data = this.additionalParseFunctions(data);

    this.setState({
      crudlState: CrudlStatus.DELETE,
      editedOrder: data,
      originalEditedOrder: JSON.stringify(data),
      validateState: ValidateState.DELETE
    });
    this.menuState(CrudlStatus.DELETE);
  };

  additionalParseFunctions = data => {
    if (format.isNotNull(data.deliveryDate)) {
      data.deliveryDate = new Date(data.deliveryDate);
    }
    if (format.isNotNull(data.orderItemResponseList)) {
      data.orderItemList = this.props.viewModel.convertOrderItemResponseToRequest(
        data.orderItemResponseList
      );
    }

    return data;
  };
  addOrder = async stayOnPage => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var orderResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.CREATE,
      stateVariables
    );

    if (orderResponse.errorCode === 0) {
      if (!format.isNotNull(stayOnPage) || stayOnPage === false) {
        await this.updateOrderList(
          orderResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      } else {
        await this.updateCurrentOrder(
          orderResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      }
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };
  updateOrder = async stayOnPage => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var orderResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.UPDATE,
      stateVariables
    );

    if (orderResponse.errorCode === 0) {
      if (!format.isNotNull(stayOnPage) || stayOnPage === false) {
        await this.updateOrderList(
          orderResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      } else {
        await this.updateCurrentOrder(
          orderResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      }
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  deleteOrder = async () => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var orderResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.DELETE,
      stateVariables
    );

    if (orderResponse.errorCode === 0) {
      await this.updateOrderList(
        orderResponse,
        CrudlStatus.DELETE,
        stateVariables
      );
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  updateOrderList = async (apiResponse, type, stateVariables) => {
    this.setState({ pageState: PageState.LOADING });

    await this.props.viewModel.getOrders();

    this.setState({
      viewState: ViewState.TABLE,
      crudlState: CrudlStatus.LIST,
      validateState: ValidateState.NONE,
      editedOrder: null
    });

    this.toggleOverlay(ToggleState.ON);
    this.menuState(CrudlStatus.LIST);

    this.setState({ pageState: PageState.IDLE });
  };

  updateCurrentOrder = async (apiResponse, type, stateVariables) => {
    this.setState({ pageState: PageState.LOADING });

    var orderList = await this.props.viewModel.getOrdersReturned();
    var order = {};
    if (format.isNotNull(orderList)) {
      orderList.forEach(element => {
        if (element.id === apiResponse.id) {
          order = format.deepCopy(element);
        }
      });
    }
    this.updateSetup(order);
    this.setState({ pageState: PageState.IDLE });
  };

  render() {
    return (
      <React.Fragment>
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />

        {/*VERY VERY BAD ERROS ONLY eg PAGE LOAD*/}
        {this.state.pageState === PageState.ERROR && (
          <ErrorScreen
            loading={this.state.pageState === PageState.LOADING}
            refresh={this.setPageData}
          />
        )}

        {this.state.pageState !== PageState.ERROR && (
          <OrderView
            viewState={this.state.viewState}
            validateState={this.state.validateState}
            crudlState={this.state.crudlState}
            menuState={this.state.menuState}
            updateEdited={this.updateBean}
            updateState={this.updateState}
            validateChanges={this.validateChanges}
            discardChanges={this.discardChanges}
            checkRequiredFields={this.checkRequiredFields}
            crudlExecute={this.executeCrudl}
            crudlControl={this.executeSetup}
            refresh={this.setPageData}
            loading={this.state.pageState === PageState.LOADING}
            export={this.export}
            editedObject={this.state.editedOrder}
            selectedOrderItems={this.state.selectedOrderItems}
            selectedOrderItemsDialog={this.state.selectedOrderItemsDialog}
            orderList={this.state.orderList}
            orderExpandedRows={this.state.orderExpandedRows}
            selectOrder={this.selectOrder}
            resetOrderItems={this.resetOrderItems}
            deletedOrderItemList={this.state.deletedOrderItemList}
            //TABLE SPECIFIC PROPS
            tableColumns={this.state.tableColumns}
            columnOptions={this.state.columnOptions}
            columnToggle={this.columnToggle}
            tableReference={this.state.tableReference}
            expandedRows={this.state.expandedRows}
            rowCount={this.state.rowCount}
            settingsToggle={this.state.settingsToggle}
            //
            customerOptions={this.state.customerOptions}
            customerList={this.state.customerList}
            //PRODUCT SPECIFIC PROPS
            productList={this.state.productList}
            productTableColumns={this.state.productTableColumns}
            productExpandedRows={this.state.productExpandedRows}
            productAddModal={this.state.productAddModal}
            hideProductEditor={this.hideProductEditor}
            removeProductFromSelectedProducts={
              this.removeProductFromSelectedProducts
            }
            updateProductSelected={this.updateProductSelected}
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Orders/OrderController.js